module.exports = __webpack_public_path__ + "media/images/bus/conditions/AMEN-93b38c2650cbc363feea4c044300fe85.svg";